/** Public pages about the app (appsbybaa.com); opened in the system browser. */
export const PRIVACY_URL = 'https://appsbybaa.com/costline/privacy/';

export function openExternal(url: string) {
  window.open(url, '_blank', 'noopener,noreferrer');
}

/**
 * Terms of use for the Premium subscription: Apple's standard licence
 * (EULA), which App Review asks to see linked beside auto-renewing plans.
 */
export const TERMS_URL = 'https://www.apple.com/legal/internet-services/itunes/dev/stdeula/';

/** Costline in the App Store (Apple ID 6817191449). */
export const APP_STORE_URL = 'https://apps.apple.com/app/id6817191449';
